import { magicLinkClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import type { Session, User } from 'better-auth';

const apiBaseUrl = (import.meta.env.VITE_API_URL ?? '').replace(/\/+$/u, '');

if (!apiBaseUrl) {
  console.error('VITE_API_URL is missing.');
}

export const authClient = createAuthClient({
  baseURL: apiBaseUrl,
  fetchOptions: {
    credentials: 'include',
  },
  plugins: [magicLinkClient()],
});

export type AuthSession = { session: Session; user: User };
export type AuthUser = AuthSession['user'];
